module.exports = __webpack_public_path__ + "static/img/KR.abd2d679.jpg";